<template>
  <div class="general main-top-margin">
    <div class="action-wrapper">
      <v-btn elevation="0" color="error" @click="deleteItem" v-if="item && item.isDeleteable">
                  <v-icon left>mdi-trash-can-outline</v-icon>
                  <lang t="DELETE ITEM"></lang>
                </v-btn>
    </div>
    <v-tabs
      @change="changeTab"
      v-model="activeTab"
      background-color="transparent"
      color="#26262A"
      slider-color="#26262A"
      light
      class="tabs-primary"
      slider-size="4"
    >
      <v-tab><lang t="ITEM-TAB-DETAILS"></lang></v-tab>
      <template v-if="currentUser.role != 'prdSysSup'">
        <v-tab><lang t="ITEM-TAB-VALUE-CHAIN-PROPERTIES"></lang></v-tab>
        <v-tab><lang t="ITEM-TAB-SCAN_PROTOCOL"></lang></v-tab>
        <v-tab><lang t="ITEM-TAB-PROTOCOL"></lang></v-tab>
      </template>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item class="py-6 px-0">
        <div v-if="isLoading" class="text-center ma-12">
          <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
        </div>

        <template v-else>
          <div class="mt-4">
            <v-row dense>
              <v-col cols="6">
                <div class="item__desc-field">
                  <v-textarea
                    :readonly="isReadonly"
                    v-model="item.shortDescription"
                    auto-grow
                    dense
                    :label="$t('ARTICLE-SHORT_DESCRIPTION')"
                    rows="2"
                  />

                </div>
              </v-col>
              <v-col cols="6">
                <div class="item__desc-field">
                  <v-textarea dense :readonly="isReadonly" v-model="item.description" auto-grow :label="$t('ARTICLE-DESCRIPTION')" rows="2" />
                </div>
              </v-col>
              <v-col cols="6">
              </v-col>
            </v-row>
          </div>
          <v-expansion-panels flat v-model="expansionPanel">
            
            <simple-item-extension-panel
              v-for="(variant, index) in item.cases"
              :key="variant"
              :selectedPanels="[expansionPanel]"
              :title="variant.name"
              :index="index"
              @updateName="updateBundleName($event, index)"
              editable
            >
              <template v-slot:action-before>
                <v-switch
                  class="defaultBundleSwitcher ml-5"
                  v-if="item.cases.length > 1"
                  :key="activeBundle[index].id"
                  v-model="activeBundle[index]._isDefaultCase"
                  dense
                  @click.stop.prevent=""
                  @change="setDefaultCaseBundleId(item, activeBundle[index])"
                />
              </template>

              <v-row>
                <v-col cols="3" v-for="(el, indexBundle) in bundleList[index]" :key="indexBundle">
                  <general-data
                    :bundle="el.bundle"
                    :bundleType="el.type"
                    :isReadonly="isReadonly"
                    :isSingle="el.singleBundle"
                    :detailsAmount="detailsAmount"
                    :activeBundleType="activeBundleType[index]"
                    @deleteBundle="deleteBundle"
                    @setActiveBundleType="updateActiveBundleType($event, index)"
                    @updateDetailsAmount="updateDetailsAmount"
                    @attributeUpdated="updateAttribute($event, index)"
                  />
                </v-col>
              </v-row>
              <template v-if="isItemDetailsLoading != index">
                <v-row>
                  <v-col cols="12">
                    <surface-list
                      :bundle="activeBundle[index]"
                      :items="activeBundleAttributeDetails[index]"
                      @attributeUpdated="updateAttribute($event, index)"
                    />
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12">
                    <attribute-list
                      :propBundle="activeBundle[index]"
                      :items="activeBundleAttributeDetails[index]"
                      @showTestResult="showTestResult"
                      @updateBundle="updateBundle($event, index, getActiveBundleKey(index, activeBundleType[index]))"
                      @attributeUpdated="updateAttribute($event, index)"
                    />
                  </v-col>
                </v-row>
                  <template v-if="['case', 'pack', 'unit'].includes(activeBundleType[index])">
                    
                  <Box class="mt-4">
                    <v-row v-if="currentUser.role == 'prdSysSup' && activeBundleType[index] === 'case'" >
                      <v-col style="min-width: 250px; font-size: 12px;" cols="4" s="12" xs="12">
                        <form class="my-8" v-if="currentUser.role == 'prdSysSup'">
                          <v-select
                            :items="['yes', 'no', 'conditional', 'incomplete']"
                            :label="$t('BUNDLE_AUTOMATION_READINESS')"
                            v-model="activeBundle[index].annotation.productionsystemReadiness"
                            class="mt-0"
                          />

                          <v-textarea
                            v-model="activeBundle[index].annotation.comment"
                            auto-grow
                            :label="$t('BUNDLE_AUTOMATION_READINESS-DESCRIPTION')"
                            rows="4"
                          ></v-textarea>

                          <v-row class="justify-end">
                            <v-btn right elevation="0" light rounded small color="themeColor" @click="saveAnnotation(activeBundle[index])"
                              ><lang t="GLOBAL-BTN-SAVE"></lang
                            ></v-btn>
                          </v-row>
                        </form>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col>
                        <v-select
                          :key="activeBundle[index]._bundlegroup_id + '-' + activeBundle[index].bundlegroup_id"
                          v-if="bundleGroups != null && bundleGroups.length"
                          :items="getBundleGroups(index)"
                          :label="$t('SELECT-BOX-BUNDLE_GROUPS')"
                          v-model="activeBundle[index].bundlegroup_id"
                          item-text="name"
                          item-value="id"
                          :return-object="false"
                          :readonly="false"
                          @input="onChangeItemGroup(activeBundle[index], index)"
                          :loading="bundleGroupsLoading"
                          class="mt-4"
                        />
                      </v-col>

                      <v-col cols="auto">
                        <v-btn
                          :disabled="isDisabled || activeBundle[index].bundlegroup_id == null"
                          elevation="0"
                          light
                          rounded
                          color="secondary"
                          fab
                          text
                          x-small
                          @click="onBundleGroupRemove(variant)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </Box>

                </template>
              </template>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
              </div>
            </simple-item-extension-panel>
          </v-expansion-panels>
        </template>
      </v-tab-item>

      <!-- Value Chain Properties -->
      <v-tab-item class="py-6 px-0">
        <div v-if="isValueChainPropertiesLoading" class="text-center ma-12">
          <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
        </div>

        <template v-else>
          <ValueChainProperties :properties="valueChainProperties" @syncProperties="syncValueChainProperties"/>          
        </template>
      </v-tab-item>
      <!-- SCAN PROTOCOLS -->
      <v-tab-item class="pa-6">
        <div v-if="!scansLoaded" class="text-center ma-12">
          <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
        </div>

        <div v-else-if="scansLoaded">
          <v-data-table
            hide-default-footer
            :headers="scanProtocolsHeaders"
            :items="scanProtocols"
            :items-per-page="25"
            class="general-table"
            :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
          >
            <template v-slot:header.image="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-IMAGE"></lang>
            </template>

            <template v-slot:header.started_at="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-STARTED_AT"></lang>
            </template>

            <template v-slot:header.origin="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-ORIGIN"></lang>
            </template>

            <template v-slot:header.bundle.name="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-BUNDLE_NAME"></lang>
            </template>

            <template v-slot:header.result="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-RESULT"></lang>
            </template>

            <template v-slot:header.user.name="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-USERNAME"></lang>
            </template>

            <template v-slot:header.multiscanProtocol="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-MULTISCAN_PROTOCOL"></lang>
            </template>

            <template v-slot:header.show_body="{ header }"> </template>

            <template v-slot:item.started_at="{ item }">
              {{ dateFormat(item.started_at) }}
            </template>

            <template v-slot:item.multiscanProtocol="{ item }">
              <template v-if="item.multiscanProtocol != null">
                <v-btn text @click="showProtocolBody(item.result)">
                  <lang t="BTN-SHOW_PROTOCOL_BODY"></lang>
                </v-btn>
              </template>

              <template v-else> </template>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>

      <!-- PROTOCOL -->
      <v-tab-item class="pa-6">
        <div v-if="!protocolsLoaded" class="text-center ma-12">
          <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
        </div>

        <div v-else-if="protocolsLoaded">
          <v-data-table
            :headers="protocolsHeaders"
            :items="protocols"
            :items-per-page="15"
            class="general-table"
            :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
          >
            <template v-slot:header.created_at="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-CREATED_AT"></lang>
            </template>

            <template v-slot:header.request_ip="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-IP_ADDRESS"></lang>
            </template>

            <template v-slot:header.type="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-TYPE"></lang>
            </template>

            <template v-slot:header.status_code="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-STATUS_CODE"></lang>
            </template>

            <template v-slot:header.error_code="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-ERROR_CODE"></lang>
            </template>

            <template v-slot:header.processing_ms="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-PROCESS_MS"></lang>
            </template>

            <template v-slot:header.show_body="{ header }"> </template>

            <template v-slot:item.created_at="{ item }">
              {{ dateFormat(item.created_at) }}
            </template>

            <template v-slot:item.show_body="{ item }">
              <v-btn text @click="showProtocolBody(item.body)">
                <lang t="BTN-SHOW_PROTOCOL_BODY"></lang>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="dialog.show" :max-width="dialog.width" :persistent="dialog.type != 'PROTOCOL'">
      <div style="background-color: #FFF" v-if="dialog.type == 'testResult'">
        <div v-if="testing.isLoading">
          <v-container style="height: 250px;">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col cols="12" class="text-center"><lang t="DERIVATION_RULES-IS_CALCULATING"/></v-col>
              <v-col cols="6">
                <v-progress-linear color="themeColor" indeterminate rounded height="6"> </v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <template v-else-if="!testing.isLoading">
          <rules-editor
            :calculation="testing.testResult"
            :testResult="testing.testResult"
            :ruleSettings="testing.settings"
            :constants="testing.constants"
            mode="testing"
            @closeModal="closeModal"
          />

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal()"><lang t="GLOBAL-BTN-CLOSE"></lang></v-btn>
          </v-card-actions>
        </template>
      </div>

      <v-card v-else>
        <v-card-title>
          <span class="headline"><lang :t="dialog.title"></lang></span>
        </v-card-title>

        <!-- BUNDLE -->
        <template v-if="dialog.type == 'BUNDLE'">
          <v-card-text>
            <v-text-field :label="$t('ARTICLE-BUNDLE-NAME')" v-model="editedItem.name"></v-text-field>
            <v-text-field :label="$t('ARTICLE-BUNDLE-GTIN')" v-model="editedItem.gtin"></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal" :disabled="dialog.isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
            <v-btn elevation="0" light rounded color="themeColor" @click="bundleSave()"><lang t="GLOBAL-BTN-SAVE"></lang></v-btn>
          </v-card-actions>
        </template>

        <!-- PROTOCOL -->
        <template v-else-if="dialog.type == 'PROTOCOL'">
          <v-card-text>
            <pre>{{ formatXml(protocolSelected) }}</pre>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal" :disabled="dialog.isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>

    <div style="position: fixed; bottom: 1em; right: 1em; z-index: 99;">
      <v-btn
        v-if="!isDisabled"
        color="secondary"
        :loading="isSaving"
        :disabled="(!isItemChanged && !valueChainPropertiesChanged) ||!isValueChainProperitesFormValid"
        @click="save()"
      >
        <small><lang t="GLOBAL-BTN-SAVE"/></small>
      </v-btn>
      <v-btn
        style="margin-left: 1em;"
        v-if="!isDisabled && activeTab === 1"
        color="secondary"
        :loading="isSavingNext"
        :disabled="(!isItemChanged && !valueChainPropertiesChanged) ||!isValueChainProperitesFormValid"
        @click="savenNext()"
      >
        <small><lang t="GLOBAL-BTN-SAVE-NEXT"/></small>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ValueChainProperties from '../../components/item/ValueChainProperties'
import Box from "../../components/ui-elements/Box";
import RulesEditor from "../settings/derivationRules/RulesEditor";
import SimpleItemExtensionPanel from "@/components/panels/SimpleItemExtensionPanel.vue";
import GeneralData from "../../components/item/GeneralData.vue";
import SurfaceList from "@/components/item/SurfaceList.vue";
import AttributeList from "@/components/item/AttributeList.vue";
import { cloneDeep, isEqual } from "lodash";
import { delay } from "@/utilities/utility";
import ConfirmDialog from "../../components/ui-elements/ConfirmDialog.vue";
import ValueChainAttributes from "../../components/item/ValueChainAttributes.vue";
import BoxItem from "../../components/ui-elements/BoxItem.vue";
export default {
  name: "ItemDetail",
  components: {
    ValueChainProperties,
    Box,
    RulesEditor,
    SimpleItemExtensionPanel,
    GeneralData,
    SurfaceList,
    AttributeList,
    ConfirmDialog,
    ValueChainAttributes,
    BoxItem
},
  computed: {

    redirectToPropertyUnit(){
        return this.$store.getters['showArticlePropertiesTabUnit'];
    },

    getActiveBundleKey() {
      return (index, type) => {
        if (!this.bundleList.length) return "";
        const bundleItem = this.bundleList[index].find((el) => el.type === type);
        if (!bundleItem) return null;
        return bundleItem.key;
      };
    },
    getBundleGroups(){
      return (index) => {
        return this.bundleGroups.filter(el => el.level === this.activeBundleType[index]);
      }
    },

    itemId() {
      return parseInt(this.$route.params.id);
    },

    isValueChainProperitesFormValid() {
          return this.$store.getters.isValueChainProperitesFormValid;
    },
    isReadonly() {
      return this.currentUser.role == "prdSysSup";
    },

    isDisabled() {
      return this.currentUser.role == "prdSysSup";
    },
    isPageTitleUpdated(){
      return this.$store.getters['isPageTitleUpdated'];
    },
    hasValueChainProperties(){
      return this.valueChainProperties && Object.entries(this.valueChainProperties).length > 0;
    },
    valueChainPropertiesChanged(){
      return !isEqual(this.defaultValueChainProperties, this.valueChainProperties);
    }
  },

  data: () => ({
    expansionPanel: 0,
    valueChainProperties: null,
    defaultValueChainProperties: null,
    isValueChainPropertiesLoading: false,
    isLoading: false,
    isSaving: false,
    isSavingNext: false,
    activeTab: 0,
    item: null,
    allAttributes: [],
    attributeItems: [],
    bundleAttributes: [],
    defaultItem: null,
    isItemChanged: false,
    bundleList: [],
    activeBundleType: [],
    detailsAmount: 0,
    activeBundle: [],
    activeBundleAttributeDetails: [],
    scansLoaded: false,
    scanProtocols: null,
    isItemDetailsLoading: -1,
    scanProtocolsHeaders: [
      {
        text: "IMAGE",
        value: "image",
        sortable: false,
      },
      {
        text: "STARTED_AT",
        value: "started_at",
        sortable: false,
      },
      {
        text: "ORIGIN",
        value: "origin",
        sortable: false,
      },
      {
        text: "BUNDLE_NAME",
        value: "bundle.name",
        sortable: false,
      },
      {
        text: "RESULT",
        value: "result",
        sortable: false,
      },
      {
        text: "USERNAME",
        value: "user.name",
        sortable: false,
      },
      {
        text: "MULTISCAN_PROTOCOL",
        value: "multiscanProtocol",
        sortable: false,
      },
    ],
    protocolsLoaded: false,
    protocols: null,
    protocolSelected: null,

    protocolsHeaders: [
      {
        text: "CREATED",
        value: "created_at",
        sortable: false,
      },
      {
        text: "IP",
        value: "request_ip",
        sortable: false,
      },
      {
        text: "TYPE",
        value: "type",
        sortable: false,
      },
      {
        text: "STATUS_CODE",
        value: "status_code",
        sortable: false,
      },
      {
        text: "ERROR_CODE",
        value: "error_code",
        sortable: false,
      },
      {
        text: "PROCESS_MS",
        value: "processing_ms",
        sortable: false,
      },
      {
        text: "SHOW_BODY",
        value: "show_body",
        sortable: false,
      },
    ],

    dialog: {
      show: false,
      isSaving: false,
      title: null,
      type: null,
      width: "640px",
    },

    bundleGroups: [],
    bundleGroupsLoading: true,

    editedItem: {
      name: null,
      gtin: null,
      level: null,
    },

    defaultEditedItem: {
      name: null,
      gtin: null,
      level: null,
    },

    testing: {
      calculation: null,
      settings: null,
      testResult: null,
      constants: null,
      isLoading: false,
    },
  }),

  watch: {
    "dialog.show"(val) {
      val || this.closeModal();
    },
    redirectToPropertyUnit:{
      handler(value){
        if(!value) return;
        if(this.activeTab === 0){
          this.changeTab(1);
          this.activeTab = 1;
        }
      },
      immediate: true
    },
    activeBundleType: {
      async handler() {
        this.setActiveBundle();
        this.setActiveBundleAttributeDetails();
        await delay(500);
        this.isItemDetailsLoading = -1;
      },
      deep: true,
    },
    item: {
      handler() {
        this.checkItem();
      },
      deep: true,
    },
    "isPageTitleUpdated"(status){
      if(!status) return;
      this.item.name = this.$route.meta.pageTitle;
      this.save();
      this.$store.commit("PAGE_TITLE_UPDATED", false);
    }
  },
  created() {
    this.isLoading = true;
    this.bundleGroupsLoading = true;

    this.axios.get(this.$config.api + "/bundlegroups").then((res) => {
      this.bundleGroups = res.data.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      this.bundleGroupsLoading = false;
    });
    this.$store.commit('SET_VALUE_CHAIN_PROPERTIES_FORM_STATUS', true);
    this.$store.commit('SET_VALUE_CHAIN_SAVED', false);
    this.initialize();
    this.loadAttributes();
  },

  methods: {
    loadAttributes(){
        this.axios.get("attributes").then((res) => {
          this.allAttributes = cloneDeep(res.data);
          this.attributeItems = res.data.filter((el) => el.isItemAttribute);
          this.bundleAttributes = res.data.filter((el) => el.isBundleAttribute);
        });
      },
    deleteItem(){
      const name = this.$route.meta.pageTitle;
      this.$confirm(this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { name }), {
        buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
        buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
      }).then((res) => {
        if (res) {
          this.axios.delete("items/" + this.itemId).then((res) => {
              this.$router.push({ name: "items" });
          });
        }
      });
    },
    checkItem() {
      this.isItemChanged = !isEqual(this.item, this.defaultItem);
    },
    updateDetailsAmount(amount) {
      if (amount > this.detailsAmount) this.detailsAmount = amount;
    },
    updateAttribute(attribute, index) {
      const foundIndex = this.activeBundleAttributeDetails[index].findIndex((el) => el.attribute.name === attribute.name);
      if (foundIndex === -1) {
        this.activeBundleAttributeDetails[index].push({attribute, info: null});
      }else{
        this.activeBundleAttributeDetails[index][foundIndex] = Object.assign(this.activeBundleAttributeDetails[index][foundIndex], { attribute });
      }
      this.updateAtributeOnItem(attribute, index);
    },
    updateAtributeOnItem(attribute, index) {
      const key = this.getActiveBundleKey(index, this.activeBundleType[index]);
      let foundAttributeIndex = -1;
      if (key) {
        if (key == "child.child") {
          foundAttributeIndex = this.item.cases[index].child.child.attributesDetails.findIndex((el) => el.attribute.name === attribute.name);
        } else {
          foundAttributeIndex = this.item.cases[index].child.attributesDetails.findIndex((el) => el.attribute.name === attribute.name);
        }
      } else {
        foundAttributeIndex = this.item.cases[index].attributesDetails.findIndex((el) => el.attribute.name === attribute.name);
      }
      if(foundAttributeIndex === -1){
        if(key){
          if(key == 'child.child'){
            this.item.cases[index].child.child.attributesDetails.push({attribute, info: null});
          }else{
            this.item.cases[index].child.attributesDetails.push({attribute, info: null});
          }
        }else{
          this.item.cases[index].attributesDetails.push({attribute, info: null});
        }
      }else{
        if (key) {
          if (key == "child.child") {
            this.item.cases[index].child.child.attributesDetails[foundAttributeIndex].attribute = attribute;
          } else {
            this.item.cases[index].child.attributesDetails[foundAttributeIndex].attribute = attribute;
          }
        } else {
          this.item.cases[index].attributesDetails[foundAttributeIndex].attribute = attribute;
        }
      }
    },
    updateActiveBundleType(payload, index) {
      this.isItemDetailsLoading = index;
      this.$set(this.activeBundleType, index, payload.type);
      this.$set(this.activeBundleAttributeDetails, index, payload.attributeDetails);
    },
    setActiveBundle() {
      if (!this.bundleList.length) return (this.activeBundle = []);
      for (let i = 0; i < this.bundleList.length; i++) {
        const bundleItem = this.bundleList[i].find((el) => el.type === this.activeBundleType[i]);
        if (!bundleItem) throw new Error("Unsupported bundle type");
        this.activeBundle[i] = bundleItem.bundle;
      }
    },
    setActiveBundleAttributeDetails() {
      if (!this.bundleList.length) return (this.activeBundle = []);
      for (let i = 0; i < this.bundleList.length; i++) {
        const bundleItem = this.bundleList[i].find((el) => el.type === this.activeBundleType[i]);
        if (!bundleItem) throw new Error("Unsupported bundle type");
        this.activeBundleAttributeDetails[i] = bundleItem.attributeDetails || [];
      }
    },
    updateBundle(bundle, index, key) {
      if (key) {
        this.item.cases[index][key] = cloneDeep(bundle);
      } else {
        this.item.cases[index] = cloneDeep(bundle);
      }
    },

    updateBundleName(name, index){
      this.item.cases[index].name = name;
      this.save();
    },
    setBundleList() {
      const output = [];
      for (let i = 0; i < this.item.cases.length; i++) {
        const list = [];
        const variant = this.item.cases[i];
        if (variant.loadcarrier != null && variant.level === "case") {
          list.push({ bundle: variant, type: "pallet", attributeDetails: cloneDeep(variant.attributesDetails), key: "" });
        }
        list.push({ bundle: variant, type: "case", key: "", attributeDetails: cloneDeep(variant.attributesDetails) });
        if (variant.child != null) {
          if (variant.child.level == "unit") {
            list.push({ bundle: variant, type: "unit", attributeDetails: cloneDeep(variant.attributesDetails), key: "" });
          } else if (variant.child.level == "pack") {
            list.push({ bundle: variant.child, type: "pack", attributeDetails: cloneDeep(variant.child.attributesDetails), key: "child" });
            if (variant.child.child != null && variant.child.child.level == "unit") {
              list.push({
                bundle: variant.child.child,
                type: "unit",
                attributeDetails: cloneDeep(variant.child.child.attributesDetails),
                key: "child.child",
              });
            }
          }
        }

        const availableBundleTypes = ["pallet", "case", "pack", "unit"];
        if (list.length === 1) {
          // only single bundle available
          list[0].singleBundle = true;
        }
        const missingBundleTypes = availableBundleTypes.filter((el) => !list.some((item) => item.type === el));
        if (missingBundleTypes && missingBundleTypes.length > 0) {
          missingBundleTypes.forEach((el) => {
            if (el === "pallet") {
              list.unshift({ bundle: null, type: el, attributeDetails: [], key: "" });
            } else {
              list.push({ bundle: null, type: el, attributeDetails: [], key: "" });
            }
          });
        }

        output.push(list);
      }

      this.bundleList = output;
    },
    setActiveBundleType() {
      const list = [];
      for (let i = 0; i < this.item.cases.length; i++) {
        list[i] = "case";
      }
      this.activeBundleType = [...list];
    },
    saveAnnotation(variant) {
      let saveObj = {
        productionsystemReadiness: variant.annotation.productionsystemReadiness,
        comment: variant.annotation.comment,
      };

      this.$axios.post("bundles/" + variant.id + "/annotate", saveObj).then((res) => {
        this.$store.dispatch("setSnackbar", {
          text: this.$t("GLOBAL-SUCCESSFULLY_SAVED"),
        });
      });
    },

    onBundleGroupRemove(variant) {
      variant.bundlegroup_id = null;
      variant.bundlegroup = null;
    },

    onChangeItemGroup(variant, index) {
      let group = this.bundleGroups.find((g) => g.id == variant.bundlegroup_id);

      this.$confirm(
        this.$t("CONFIRM_ADD_TO_ITEM_GROUP_MESSAGE", {
          VPE_NAME: variant.name,
          ITEM_GROUP_NAME: group.name,
        }),
        {
          title: this.$t("CONFIRM_ADD_TO_ITEM_GROUP_MESSAGE-TITLE"),
          buttonTrueText: this.$t("GLOBAL-CONFIRMATION-YES"),
          buttonFalseText: this.$t("GLOBAL-CONFIRMATION-CANCEL"),
        }
      ).then((res) => {
        if (res == true) {
          variant._bundlegroup_id = variant.bundlegroup_id;
          this.$forceUpdate();
        } else {
          variant.bundlegroup_id = variant._bundlegroup_id;
          this.$forceUpdate();
        }
      });
    },

    showTestResult(calculationrule_id, bundleId) {
      if (calculationrule_id == null || bundleId == null) {
        return;
      }

      this.testing.isLoading = true;

      this.dialog.type = "testResult";
      this.dialog.width = "96%";
      this.dialog.show = true;

      if (this.testing.constants == null) {
        const getRuleSettings = () => this.$axios.get("calculationrules/settings");
        const getConstants = () => this.$axios.get("constants");

        Promise.all([getRuleSettings(), getConstants()])
          .then(([settings, constants]) => {
            this.testing.settings = settings.data;
            this.testing.constants = constants.data;

            this.getCalculation(calculationrule_id, bundleId);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.getCalculation(calculationrule_id, bundleId);
      }
    },

    getCalculation(calculationrule_id, bundleId) {
      this.$axios
        .post("calculationrules/" + calculationrule_id + "/test", {
          bundleId: bundleId,
        })
        .then((res) => {
          this.testing.testResult = res.data;
          setTimeout(() => {
            this.testing.isLoading = false;
          }, 500);
        });
    },

    setDefaultCaseBundleId(item, variant) {
      // reset all _isDefaultCase for every item except the selected one
      item.cases.forEach((c) => {
        if (c.id != variant.id) {
          c._isDefaultCase = false;
        }
      });

      // force update do reflect changes in DOM
      this.$forceUpdate();

      // set the item.defaultBundle id to the selected bundle id (if switcher == true),
      // otherwise set it to null
      item.defaultBundle_id = variant._isDefaultCase ? variant.id : null;
    },

    showProtocolBody(protocol) {
      this.protocolSelected = protocol;
      this.dialog.type = "PROTOCOL";
      this.dialog.title = "ARTICLE-PROTOCOL-BODY";
      this.dialog.width = "85%";
      this.dialog.show = true;
    },

    syncValueChainProperties(properties){
        this.valueChainProperties = cloneDeep(properties);
    },

    bundleSave() {
      this.dialog.isSaving = true;

      let parentId = null;

      if (this.bundles[this.editedItem.level] != null && typeof this.bundles[this.editedItem.level].parent_id != "undefined") {
        parentId = this.bundles[this.editedItem.level].parent_id;
      } else {
        parentId = this.item.id;
      }

      this.axios
        .post("bundles/" + parentId + "/insert", this.editedItem)
        .then((res) => {
          this.dialog.isSaving = false;

          this.closeModal();
          this.initialize();
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
          });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-ERROR"),
            type: "error",
          });
          this.dialog.isSaving = false;
        });
    },

    closeModal() {
      this.dialog.show = false;
      this.dialog.isSaving = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultEditedItem);
      });
    },

    changeTab(tab) {
      if(tab === 1 && this.valueChainProperties === null){
        this.loadValueChainProperties();
      }else if (tab == 2 && this.scanProtocols == null) {
        this.fetchScanProtocols();
      } else if (tab == 3 && this.protocol == null) {
        this.fetchProtocol();
      }
    },

    fetchScanProtocols() {
      this.scansLoaded = false;
      let bundleId = this.item.cases[0].id;

      this.axios.get("scans?bundle_id=" + bundleId).then((res) => {
        this.scanProtocols = res.data;
        this.scansLoaded = true;
      });
    },

    fetchProtocol() {
      this.protocolsLoaded = false;

      this.axios.get("items/" + this.itemId + "/wmsProtocol").then((res) => {
        this.protocols = res.data;
        this.protocolsLoaded = true;
      });
    },

    formatXml(xml) {
      var formatted = "";
      var reg = /(>)(<)(\/*)/g;
      xml = xml.replace(reg, "$1\r\n$2$3");
      var pad = 0;

      xml.split('\r\n').forEach((node, index) => {
      let indent = 0;
      if (/^<\/\w/.exec(node)) {
        if (pad != 0) {
          pad -= 1;
        }
      } else if (/^<\w[^>]*[^\/]>.*$/.exec(node)) {
        indent = 1;
      }

      let padding = '';
      for (let i = 0; i < pad; i++) {
        padding += '  ';
      }

        formatted += padding + node + "\r\n";
        pad += indent;
      });
      return formatted;
    },

    loadValueChainProperties(){
      this.isValueChainPropertiesLoading = true;
      this.axios.get(`items/${this.itemId}/properties`).then((res) => {
        this.valueChainProperties = res.data;
        this.defaultValueChainProperties = cloneDeep(res.data);
        this.isValueChainPropertiesLoading = false;
      });   
    },

    initialize() {
      return this.axios.get("items/" + this.itemId).then((res) => {
        this.item = res.data;
        this.item.cases.forEach((c) => {
          c._isDefaultCase = this.item.defaultBundle_id != null && this.item.defaultBundle_id == c.id;
          c._bundlegroup = c.bundlegroup;
          c._bundlegroup_id = c.bundlegroup_id;
        });

        this.changeTitle();
        this.setBundleList();
        this.setActiveBundleType();
        this.isLoading = false;
        this.defaultItem = cloneDeep(this.item);
      });
    },

    changeTitle() {
      let title = this.item.name;
      if(this.item.kisoftId){
        title += ` (${this.item.kisoftId})`;
      }
      this.$route.meta.pageTitle = `${title}`;

      // Add a temporary query parameter.
      this.$router.replace({ query: { temp: Date.now() } });

      // Remove the temporary query parameter.
      this.$router.replace({ query: { temp: undefined } });
    },

    updateValueChainProperties(){
      this.axios.put(`items/${this.itemId}/properties`, this.valueChainProperties).then((res) => {
        this.valueChainProperties = cloneDeep(res.data);
        this.$store.commit('SET_VALUE_CHAIN_SAVED', true);
      });
    },

    savenNext(){
      this.save(true);

    },

    save(next = false) {
      if(next){
        this.isSavingNext = true;
      }else{
        this.isSaving = true;
      }

      this.axios
        .put("items/" + this.item.id, this.item)
        .then((res) => {
          let expansionPanelIndex = this.item.cases.findIndex((c) => c.item_id == this.item.id);

          this.initialize().then((res) => {
            if (expansionPanelIndex > -1) {
              this.expansionPanel = expansionPanelIndex;
            }
          });

          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-SUCCESSFULLY_SAVED"),
          });
          if(this.valueChainPropertiesChanged){
            this.updateValueChainProperties();
          }
          if(next){
            return this.$router.push({ name: "items" });
          }
          this.isSaving = false;
          this.defaultItem=cloneDeep(this.item);
          this.checkItem();
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-SAVING_ERROR") + ": " + err.response.statusText,
            type: "error",
          });
          this.isSaving = false;
          this.checkItem();
        });
    },

    deleteBundle(bundle) {
      this.$confirm(this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { name: bundle.name }), {
        buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
        buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
      }).then((res) => {
        if (res) {
          this.axios.delete("bundles/" + bundle.id).then((res) => {
            this.initialize();
            this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL-SUCCESSFULLY_DELETED"),
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.action-wrapper{
  position: absolute;
  top: -60px;
  right: 0;
  width: 140px;
}

.bundle {
  line-height: normal !important;
  min-height: 150px;

  &.empty {
    cursor: pointer;
    background-color: #fafafa !important;
    border: 1px dashed #ddd !important;

    &:hover {
      border: 1px dashed #aaa !important;
    }
  }
  .v-subheader {
    font-weight: bold;
  }
}

.defaultBundleSwitcher {
  label {
    font-size: 11px;
  }
}

.v-expansion-panel-header {
  padding: 0 12px;
  strong,
  .defaultBundleSwitcher {
    flex: 0 1 auto !important;
  }
}
.v-expansion-panel-content__wrap {
  padding: 16px 0;
}
</style>
